import React, { useState } from 'react';
import "./style.scss";
import classNames from 'classnames';
import { formattedTableHeaders } from '../../../utils';

const TableComponent = ({ tableData, onSort }) => {

    const [sortColumn, setSortColumn] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);

    const sortClickHandler = (column) => {

        let newOrder = 'ASC';
        if (sortColumn === column) {
            newOrder = sortOrder === 'ASC' ? 'DESC' : 'ASC'
        }

        setSortColumn(column);
        setSortOrder(newOrder);
        onSort(column, newOrder);
    }

    const tableheaders = tableData && tableData.length > 0 ? Object.keys(tableData[0]) : [];

    return (
        <div className='table_container'>
            <table className='table_container__table'>
                <thead>
                    <tr>
                        {tableheaders.map((header, index) => {
                            const tableHeader = formattedTableHeaders(header);
                            return (<th key={index} >
                                <div className='table_container__table__header'>
                                    <p className='table_container__table__header__text'>{tableHeader}</p>
                                    <p onClick={() => sortClickHandler(header)} className={classNames('table_container__table__header__sort-icon', { 'table_container__table__header__sort-icon__clicked': sortOrder === 'ASC' })}><svg xmlns="http://www.w3.org/2000/svg" width="9" height="6" viewBox="0 0 7 4" fill="none">
                                        <path d="M0.75296 1.2843L3.42502 3.29935L6.09708 1.2843" stroke="#D9D9D9" />
                                    </svg></p>
                                </div>
                            </th>)
                        })}
                    </tr>
                </thead>
                <tbody>
                    {tableData && tableData.map((rowData, i) => (
                        <tr key={i}>
                            {tableheaders.map((header, i) => (
                                <td key={i}>{rowData[header]}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default TableComponent;